// For Eslint
/* global google */

import { Controller } from '@hotwired/stimulus'
import t from '../functions/t'

const infoPoint = (code, address, phone, schedule, directions) => {
  return `
    <a
      href='#'
      class="btn btn-success btn-block"
      onclick="document.dispatchEvent(new CustomEvent('boxberry:point-picked', { detail: { point_code: ${code} } })); return false;"
    >
      ${t('boxberry.service.points.info.update')}
    </a>
    <dl style="margin-top: 1rem;">
      <dt>${t('boxberry.service.points.info.address')}</dt>
      <dd>${address}</dd>
      <dt>${t('boxberry.service.points.info.phone')}</dt>
      <dd>${phone}</dd>
      <dt>${t('boxberry.service.points.info.schedule')}</dt>
      <dd>${schedule}</dd>
      <dt>${t('boxberry.service.points.info.directions')}</dt>
      <dd>${directions}</dd>
    </dl>
  `
}

const pinPoint = (map, point) => {
  const {
    code,
    address,
    phone,
    schedule,
    directions,
    gps: [latitude, longitude],
  } = point

  const marker = new google.maps.Marker({
    position: new google.maps.LatLng(latitude, longitude),
    map: map,
  })

  const markerContent = infoPoint(code, address, phone, schedule, directions)
  const infoWindow = new google.maps.InfoWindow({
    content: markerContent,
  })

  marker.addListener('click', () => {
    infoWindow.open({
      map,
      anchor: marker,
    })
  })
}

export default class extends Controller {
  static values = {
    searchQuery: String,
    points: String,
  }

  connect() {
    if (typeof google !== 'undefined') {
      this.initializeMap()
    }
  }

  initializeMap() {
    const geocoder = new google.maps.Geocoder()

    geocoder.geocode({ address: this.searchQueryValue }, (results, status) => {
      if (status == google.maps.GeocoderStatus.OK) {
        const latitude = results[0].geometry.location.lat()
        const longitude = results[0].geometry.location.lng()
        this.drawMap(latitude, longitude)
      }
    })
  }

  drawMap(latitude, longitude) {
    const map = new google.maps.Map(this.element, {
      zoom: 10,
      center: new google.maps.LatLng(latitude, longitude),
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      zoomControl: true,
      mapTypeControl: true,
      fullscreenControl: true,
    })

    const points = JSON.parse(this.pointsValue)
    for (const point of points) {
      pinPoint(map, point)
    }
  }
}
